import { SERVICE_TYPE } from '@/services/ModalParameterContext';
import { broadcast } from '@/broadcast';
import type { AtoneAuthCompleteType } from './context';

export default {
  useComplete: () => {
    // 画面表示後しばらくしたら完了イベントを発火。
    window.setTimeout(() => {
      broadcast.send({
        type: 'MODAL_CONTROL_SUCCEEDED',
        payload: {
          serviceType: SERVICE_TYPE.ATONE,
        },
      });
    }, 3000);
  },
} satisfies AtoneAuthCompleteType;
